import {HttpAxiosRequest} from "../httpAxiosBase";

export const HttpFiles = {
    getEndpoint: (url: string): string => `archivo${url}`,

    download: (bigIdFile: number): Promise<any> => {
        return HttpAxiosRequest.getBlob(
            HttpFiles.getEndpoint(`/descargar/${bigIdFile}`)
        );
    },

    delete: (bigIdFile: number): Promise<any> => {
        return HttpAxiosRequest.delete(
            HttpFiles.getEndpoint(`/${bigIdFile}`)
        );
    }
}